import React from 'react';
import { createUseStyles } from 'react-jss';

const fontComponents = {
  Rubik,
  'Ibm Plex Sans': IbmPlexSans,
  'Merriweather Sans': MerriweatherSans,
  'Arima Madurai': ArimaMadurai,
  'Nanum Square': NanumSquare
};
const getFontComponent = (font) => fontComponents[font] || (() => null);

export default function FontSeeder({ fontFamily }) {
  const Comp = getFontComponent(fontFamily);

  return <Comp />;
}

const useRubikFont = createUseStyles({
  '@import': `url('https://fonts.googleapis.com/css2?family=Lato&family=Rubik:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap')`
});
function Rubik() {
  // to import "Rubik" font css
  useRubikFont();
  return null;
}

const useIbmPlexSansFont = createUseStyles({
  '@import':
    'url(https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap)'
});
function IbmPlexSans() {
  // to import "Ibm Plex Sans" font css
  useIbmPlexSansFont();
  return null;
}

const useMerriweatherSansFont = createUseStyles({
  '@import':
    'url(https://fonts.googleapis.com/css2?family=Merriweather+Sans:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap)'
});
function MerriweatherSans() {
  // to import "Merriweather Sans" font css
  useMerriweatherSansFont();
  return null;
}

const useArimaMaduraiFont = createUseStyles({
  '@import':
    'url(https://fonts.googleapis.com/css2?family=Arima+Madurai:wght@400;500;700&display=swap)'
});
function ArimaMadurai() {
  // to import "Arima Madurai" font css
  useArimaMaduraiFont();
  return null;
}

const useNanumSqaureFont = createUseStyles({
  '@import':
    'url(https://cdn.jsdelivr.net/gh/moonspam/NanumSquare@2.0/nanumsquare.css)'
});

function NanumSquare() {
  // to import "Nanum Square" font css
  useNanumSqaureFont();
  return null;
}
